import { Configuration, PublicClientApplication, LogLevel } from '@azure/msal-browser';
import { env } from './env';

export const msalConfig: Configuration = {
  auth: {
    clientId: env.AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${env.AZURE_TENANT_ID}`,
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

const audience = import.meta.env.VITE_AZURE_AUDIENCE || `api://${env.AZURE_CLIENT_ID}`;

export const apiConfig = {
  audience,
  scopes: [`${audience}/access_as_user`],
};

export const loginRequest = {
  scopes: apiConfig.scopes,
};

export const interactiveLoginRequest = {
  scopes: apiConfig.scopes,
  prompt: 'select_account' as const,
};
